import { Radio } from "..";
import useNoview7days from "../../hooks/useNoview7days";
import { Noview7daysAreaType } from "../../types/noview.type";

// https://www.figma.com/design/6K5HgksUytqidNX0MjLvQy/Potoo-Product-Design?node-id=1798-5257&t=n4S2xEJF3FPQ9Tcc-4
// modal의 7일간 보지 않기 부분
const Noview7daysArea = ({ cookieKey, expires = 7, label = "7일간 보지 않기", onChangeState, version = "" }: Noview7daysAreaType) => {
  const {
    isClickedNoview7days,
    setIsClickedNoview7days,
    setNoview7daysCookies,
  } = useNoview7days(cookieKey, expires, version);

  return (
    <div className="modal-noview7days-container">
      <Radio
        label={label}
        labelClassName="body1-500 white"
        selected={isClickedNoview7days}
        size="medium"
        onClick={() => {
          setNoview7daysCookies(!isClickedNoview7days);
          setIsClickedNoview7days(!isClickedNoview7days);

          if (onChangeState) {
            onChangeState(isClickedNoview7days);
          }
        }}
      />
    </div>
  );
};

Noview7daysArea.defaultProps = {
  expires: 7,
  label: "7일간 보지 않기"
};

export { Noview7daysArea };
